import { IUserProfile } from '../../models/IUserProfile';
import { UserActionTypes, UserProfileActions } from '../action-types/userProfileActionTypes';

export interface IUserProfileState {
  isUserProfileLoading: boolean;
  userProfileHasError: boolean;
  userProfileErrorMessage: string;
  userProfile: IUserProfile | null;
}

export const userProfileInitialState: IUserProfileState = {
  userProfile: null,
  isUserProfileLoading: false,
  userProfileHasError: false,
  userProfileErrorMessage: null,
};

export function userProfileReducer(
  prev: IUserProfileState = userProfileInitialState,
  action: UserProfileActions
): IUserProfileState {
  switch (action.type) {
    case UserActionTypes.REQUEST_USERPROFILE: {
      return {
        ...prev,
        isUserProfileLoading: true,
        userProfileHasError: false,
        userProfileErrorMessage: null,
      };
    }
    case UserActionTypes.RECEIVE_USERPROFILE: {
      return {
        ...prev,
        userProfile: action.userProfile,
        isUserProfileLoading: false,
        userProfileHasError: false,
        userProfileErrorMessage: null,
      };
    }
    case UserActionTypes.REQUEST_USERPROFILE_FAILED: {
      return {
        ...prev,
        userProfile: null,
        isUserProfileLoading: false,
        userProfileHasError: true,
        userProfileErrorMessage: action.errorMessage,
      };
    }
    default:
      return prev;
  }
}
